"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _styles = require("@material-ui/core/styles");
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Popper = _interopRequireDefault(require("../Popper"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = function useStyles(_ref) {
  var minWidth = _ref.minWidth;
  return (0, _styles.makeStyles)(function () {
    return {
      card: {
        minWidth: minWidth
      }
    };
  })();
};
var defaultProps = {
  dataMetrics: {
    actions: 'fuse_popper_dialog_actions',
    content: 'fuse_popper_dialog_content',
    root: 'fuse_popper_dialog',
    title: 'fuse_popper_dialog_title'
  },
  minWidth: '320px'
};
var PopperDialog = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _ref2$classes = _ref2.classes,
    overrideClasses = _ref2$classes === void 0 ? {} : _ref2$classes,
    dataMetrics = _ref2.dataMetrics,
    dialogTitle = _ref2.dialogTitle,
    dialogSubtitle = _ref2.dialogSubtitle,
    dialogContent = _ref2.dialogContent,
    dialogActions = _ref2.dialogActions,
    _ref2$dialogTitleProp = _ref2.dialogTitleProps,
    dialogTitleProps = _ref2$dialogTitleProp === void 0 ? {} : _ref2$dialogTitleProp,
    _ref2$dialogSubtitleP = _ref2.dialogSubtitleProps,
    dialogSubtitleProps = _ref2$dialogSubtitleP === void 0 ? {} : _ref2$dialogSubtitleP,
    _ref2$dialogContentPr = _ref2.dialogContentProps,
    dialogContentProps = _ref2$dialogContentPr === void 0 ? {} : _ref2$dialogContentPr,
    _ref2$dialogActionsPr = _ref2.dialogActionsProps,
    dialogActionsProps = _ref2$dialogActionsPr === void 0 ? {} : _ref2$dialogActionsPr,
    minWidth = _ref2.minWidth,
    PopperProps = _ref2.PopperProps;
  var classes = _objectSpread({}, useStyles({
    minWidth: minWidth
  }), {}, overrideClasses);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Popper["default"], (0, _extends2["default"])({
    "data-metrics": mergedDataMetrics.root,
    noPadding: true,
    ref: ref
  }, PopperProps), /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    classes: {
      root: classes.card
    },
    square: true
  }, dialogTitle && /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    "data-metrics": mergedDataMetrics.title,
    disableTypography: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    align: "left",
    variant: "h6"
  }, dialogTitleProps), dialogTitle), dialogSubtitle && /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    align: "left",
    variant: "subtitle1"
  }, dialogSubtitleProps), dialogSubtitle)), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], (0, _extends2["default"])({
    "data-metrics": mergedDataMetrics.content
  }, dialogContentProps), dialogContent), Boolean(dialogActions) && /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], (0, _extends2["default"])({
    "data-metrics": mergedDataMetrics.actions,
    disableSpacing: true
  }, dialogActionsProps), dialogActions)));
});
PopperDialog.displayName = 'PopperDialog';
PopperDialog.defaultProps = defaultProps;
PopperDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    actions: _propTypes["default"].string,
    content: _propTypes["default"].string,
    root: _propTypes["default"].string,
    title: _propTypes["default"].string
  }),
  /**
   * Dialog action Bar component. For instance, it can be be a `Button`, a `Switch` or a `Checkbox`.
   */
  dialogActions: _propTypes["default"].element,
  /**
   * Properties for dialog actions. For example, it can be {name:'sample-actions'}
   */
  dialogActionsProps: _propTypes["default"].object,
  /**
   * Dialog content node.
   */
  dialogContent: _propTypes["default"].node,
  /**
   * Properties for dialog content.
   */
  dialogContentProps: _propTypes["default"].object,
  /**
   * Dialog Sub Title.
   */
  dialogSubtitle: _propTypes["default"].string,
  /**
   * Properties for subtitle
   */
  dialogSubtitleProps: _propTypes["default"].object,
  /**
   * Dialog Title.
   */
  dialogTitle: _propTypes["default"].string,
  /**
   * Properties for title.
   */
  dialogTitleProps: _propTypes["default"].object,
  /**
   * Minimum width for the component.
   */
  minWidth: _propTypes["default"].string,
  /**
   * Props for the Popper component
   *
   * See **[Popper](/#/Components/Popper)** for additional information
   */
  PopperProps: _propTypes["default"].object
} : {};
var _default = PopperDialog;
exports["default"] = _default;